import React from 'react'

import VenueFeatureIcon from '../VenueFeatureIcon'

const VenueFeature = ({icon, text}) => (
  <li className="venue-feature_item">
    <VenueFeatureIcon icon={icon}/>
    <span>
        {text}
    </span>
  </li>
)

export default VenueFeature;


// WEBPACK FOOTER //
// ./src/components/VenueFeature/index.js